import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { enableMocksIfNeeded, reportToHeimdall } from '@vendasta/core';
import { AppModule } from './app/app.module';
import { devServer } from './globals';

if (!devServer) {
  enableProdMode();
}

async function bootstrap() {
  await enableMocksIfNeeded();

  platformBrowserDynamic()
    .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
    .catch((err) => {
      reportToHeimdall(err);
      console.error(err);
    });
}

bootstrap();
